import script from "./FlightDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlightDetails.vue?vue&type=script&setup=true&lang=ts"

import "./FlightDetails.vue?vue&type=style&index=0&id=7cdd9dda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cdd9dda"]])

export default __exports__